import { render, staticRenderFns } from "./homeDashboardTrainerGoals.vue?vue&type=template&id=b12ae522&scoped=true"
import script from "./homeDashboardTrainerGoals.vue?vue&type=script&lang=js"
export * from "./homeDashboardTrainerGoals.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTrainerGoals.vue?vue&type=style&index=0&id=b12ae522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12ae522",
  null
  
)

export default component.exports